<m-popup ref="popup"
        class="m-option"
        :open.sync="open"
        :padding="false"
        :placement="placement"
        :disabled="disabled"
        :close-on-backdrop="true"
        :background="false"
        :shadow="false"
        :focus-management="false"
        @open="emitOpen"
        @close="emitClose"
        @click-outside="onClickOutside">
    <button v-if="isSkinMixed"
            :id="id"
            class="m-option__button"
            aria-haspopup="dialog"
            :aria-expanded="open ? 'true': 'false'"
            :aria-label="ariaLabel"
            :disabled="disabled"
            :title="title"
            slot="trigger"
            @click="emitClick">
        <m-icon name="m-svg__options" />
    </button>
    <m-icon-button :id="id"
                    v-else
                    aria-haspopup="dialog"
                    :aria-expanded="open ? 'true': 'false'"
                    :aria-label="ariaLabel"
                    :skin="iconButtonSkin"
                    :title="title"
                    icon-name="m-svg__options"
                    :disabled="disabled"
                    :button-size="size"
                    slot="trigger"
                    @click="emitClick" />
    <div class="m-option__dialog" role="dialog" ref="menu" tabindex="-1">
        <ul class="m-option__list"
            :style="{ maxHeight: menuMaxHeight, maxWidth: optionMaxWidth }"
            :aria-label="ariaLabel">
            <slot />
            <li class="m-option__close-menu-item" :class="{'m--is-visible': isCloseButtonVisible }">
                <button class="m-option__close-menu-button"
                        @focus="onCloseButtonFocus"
                        @blur="onCloseButtonBlur"
                        @click="close">{{ $i18n.translate('m-option:close') }}</button>
            </li>
        </ul>
    </div>
</m-popup>

